import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Loader2 } from "lucide-react";

interface DescriptionStepProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  generateDescription: () => Promise<void>;
  isGenerating: boolean;
}

const DescriptionStep: React.FC<DescriptionStepProps> = ({
  value,
  onChange,
  onKeyDown,
  generateDescription,
  isGenerating,
}) => {
  return (
    <div className="space-y-2">
      <div className="relative">
        <Textarea
          name="description"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder="Describe the activity, what to expect, and any important details..."
          className="w-full p-3 rounded-xl bg-white h-40 resize-none text-sm font-light leading-relaxed focus-visible:outline-none focus-visible:ring-0"
        />
        <div className="absolute bottom-2 left-2 flex justify-between items-center">
          <button
            type="button"
            onClick={generateDescription}
            disabled={isGenerating}
            className="h-8 flex items-center gap-2 px-3 rounded-full hover:bg-indigo-50 transition-all ease-in-out duration-300 text-indigo-600 opacity-75 hover:opacity-100 hover:text-indigo-700"
            title="Generate AI description"
          >
            <span className="text-xs font-medium">
              {isGenerating ? "Generating with Tora" : "Generate with Tora"}
            </span>
            {isGenerating ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <i className="fa-solid fa-sparkles text-sm"></i>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DescriptionStep;
